import { Message } from "element-ui";
// 移动窗体的方法
const move = (e) => {
    const widnowArr = ['dialog', 'affirm', 'selectTimeFrameWidnow'];
    // 获取需要移动的窗体块
    e.path.forEach((item) => {
        if (item.classList) {
            for (let i = 0; i < item.classList.length; i++) {
                if (widnowArr.includes(item.classList.item(i))) {
                    const moveWindow = item;
                    const leftItem = e.pageX - moveWindow.offsetLeft;
                    const topItem = e.pageY - moveWindow.offsetTop;
                    document.onmousemove = (ee) => {
                        // // 获取鼠标离窗体左侧和上侧的距离
                        const l = ee.pageX - leftItem;
                        const y = ee.pageY - topItem;
                        moveWindow.style.left = l + 'px';
                        moveWindow.style.top = y + 'px';
                        document.onmouseup = () => {
                            document.onmousemove = null;
                        }
                    }
                }
            }
        }
    })
}

// 弹窗重新封装
const message = (msg) => {
    Message({
        message: msg,
        duration: 1500
    });
}
export { move, message }
